<template>
  <div class="goodsForecast">
    <div class="tag-group" v-if="preData.fpid && preData.fpdid">
      <van-tag size="large" type="primary" style="margin: 10px">{{
        preData.fpid.text
      }}</van-tag>
      <van-tag
        size="large"
        type="primary"
        style="margin-top: 10px; margin-right: 10px; margin-bottom: 10px"
        >{{ preData.fpdid.text }}</van-tag
      >
    </div>

    <van-form
      label-width="300px"
      :show-error="false"
      :scroll-to-error="false"
      @failed="nextStepFailed"
      @submit="nextStep"
      v-if="step == 1"
    >
      <div class="multi-table" v-if="expressNumbers">
        <div
          v-for="(form, index) in expressNumbers"
          :key="index"
          class="multi-table-wrapper"
        >
          <van-field
            class="custom-field"
            v-model="form.ExpressNumber"
            :label="$t.goodsForecast.expressNumber + ' ' + (index + 1)"
            :placeholder="$t.goodsForecast.expressNumberPlaceHolder"
            required
            :rules="[
              {
                required: true,
                message: $t.goodsForecast.input + ' ' + $t.goodsForecast.expressNumber,
              },
            ]"
            type="textarea"
            row="2"
          />
          <div class="multi-table-corner" v-if="index != 0">
            <div class="multi-table-btn" @click="handleDelByIndex(index)">
              <van-icon name="close" />
            </div>
          </div>
        </div>
        <van-field name="stepper" class="stepper" :label="$t.goodsForecast.stepperLabel">
          <template #input>
            <van-stepper
              :min="1"
              :max="10"
              :value="expressNumbers.length"
              @minus="handleDel"
              @plus="handleAdd"
              :disable-input="true"
            />
          </template>
        </van-field>
      </div>

      <div class="tool-bar">
        <van-button block native-type="submit">{{
          $t.goodsForecast.nextStep
        }}</van-button>
      </div>
    </van-form>
    <van-form
      label-width="300px"
      :show-error="false"
      :scroll-to-error="false"
      @failed="onFailed"
      @submit="onSubmit"
      v-if="step == 2"
    >
      <div class="forms-wrapper">
        <van-collapse v-model="activeNames" accordion :border="false">
          <van-collapse-item v-for="(form, index) in forms" :key="index" :name="index">
            <template #title>
              <van-field
                class="custom-field"
                :label="$t.goodsForecast.expressNumber"
                :placeholder="$t.goodsForecast.input"
                v-model="form.ExpressNumber"
                v-if="isEdit"
                required
                :rules="[
                  {
                    required: true,
                    message:
                      $t.goodsForecast.input + ' ' + $t.goodsForecast.expressNumber,
                  },
                ]"
                @click-input="$event.stopPropagation()"
              />
              <van-field
                class="custom-field"
                :label="$t.goodsForecast.expressNumber + ' ' + (index + 1)"
                v-model="form.ExpressNumber"
                readonly
                v-else
              />
            </template>

            <span v-if="pageType == 'edit'">
              <van-field
                class="custom-field"
                readonly
                clickable
                :value="form.fpid.text"
                :label="$t.goodsForecast.countryName"
                :placeholder="$t.goodsForecast.select"
                @click="onShowFpid(index)"
                required
                :rules="[
                  {
                    required: true,
                    message: $t.goodsForecast.select + ' ' + $t.goodsForecast.countryName,
                  },
                ]"
              />

              <van-field
                class="custom-field"
                readonly
                clickable
                :value="form.fpdid.text"
                :label="$t.goodsForecast.cargoCategory"
                :placeholder="$t.goodsForecast.select"
                @click="onShowFpdid(index)"
                v-if="form.fpid.value"
                required
                :rules="[
                  {
                    required: true,
                    message:
                      $t.goodsForecast.select + ' ' + $t.goodsForecast.cargoCategory,
                  },
                ]"
              />

              <van-field
                class="custom-field"
                v-model="form.CargoName"
                :label="$t.goodsForecast.cargoName"
                label-class="number-label"
                :placeholder="$t.goodsForecast.input"
                required
                :rules="[
                  {
                    required: true,
                    message: $t.goodsForecast.input + ' ' + $t.goodsForecast.cargoName,
                  },
                  {
                    validator: asyncValidator,
                    message:
                      $t.goodsForecast.cargoName + ' ' + $t.goodsForecast.englishOnly,
                  },
                ]"
              >
                <template #button>
                  <van-button
                    size="small"
                    type="info"
                    class="customBtn"
                    native-type="button"
                    :disabled="!form.CargoName ? true : false"
                    @click="handleTranslate(form.CargoName, null, null)"
                    >{{ $t.goodsForecast.translate }}</van-button
                  >
                </template>
              </van-field>

              <van-field
                class="custom-field half-field"
                v-model="form.CargoQuantity"
                :label="$t.goodsForecast.cargoQuantity"
                :placeholder="$t.goodsForecast.input"
                oninput="if(isNaN(value)) { value = null } if(value.indexOf('.')>0){value=value.slice(0,value.indexOf('.')+3)}"
                required
                :rules="[
                  {
                    required: true,
                    message:
                      $t.goodsForecast.input + ' ' + $t.goodsForecast.cargoQuantity,
                  },
                ]"
              >
                <template #button v-if="form.QuantityUnit">
                  <span v-if="form.IsOther">{{ form.CustomeUnit }}</span>
                  <span v-else>{{ form.QuantityUnit }}</span>
                </template>
              </van-field>

              <van-field
                class="custom-field"
                v-model="form.QuantityUnit"
                :label="$t.goodsForecast.quantityUnit"
                :placeholder="$t.goodsForecast.select"
                readonly
                required
                :rules="[
                  {
                    required: true,
                    message:
                      $t.goodsForecast.select + ' ' + $t.goodsForecast.quantityUnit,
                  },
                ]"
                @click="pickerShow('showUnitPicker', 0, 0)"
              />

              <van-field
                class="custom-field"
                v-model="form.CustomeUnit"
                :label="$t.goodsForecast.customUnit"
                :placeholder="$t.goodsForecast.input"
                required
                :rules="[
                  {
                    required: true,
                    message: $t.goodsForecast.input + ' ' + $t.goodsForecast.customUnit,
                  },
                ]"
                v-if="form.IsOther"
              />

              <van-field
                class="custom-field half-field"
                v-model="form.GoodsValue"
                :label="$t.goodsForecast.goodsValue"
                :placeholder="$t.goodsForecast.input"
                @blur="taxCalculator"
                oninput="if(isNaN(value)) { value = null } if(value.indexOf('.')>0){value=value.slice(0,value.indexOf('.')+3)}"
                required
                :rules="[
                  {
                    required: true,
                    message: $t.goodsForecast.input + ' ' + $t.goodsForecast.goodsValue,
                  },
                ]"
              >
                <template #button v-if="form.CurrencySymbol">
                  <span>{{ form.CurrencySymbol }}</span>
                </template>
              </van-field>

              <van-field
                class="custom-field half-field"
                v-model="form.Currency"
                :label="$t.goodsForecast.currency"
                :placeholder="$t.goodsForecast.select"
                readonly
                required
                :rules="[
                  {
                    required: true,
                    message: $t.goodsForecast.select + ' ' + $t.goodsForecast.currency,
                  },
                ]"
                @click="pickerShow('showCurrencyPicker', 0, 0)"
              />

              <van-field
                class="custom-field half-field"
                v-model="form.PTIdStr"
                :label="$t.goodsForecast.productCategory"
                :placeholder="$t.goodsForecast.select"
                readonly
                @click="pickerShow('showPtidPicker', 0, 0)"
                v-if="productTaxList && productTaxList.length > 0"
              />

              <van-field
                class="custom-field half-field"
                v-model="form.TotalTax"
                readonly
                disabled
                v-if="productTaxList && form.TotalTax"
              >
                <template #label>
                  <span class="custom-field-label">{{ $t.goodsForecast.totalTax }}</span
                  ><van-image
                    width="15"
                    height="15"
                    :src="questionIcon"
                    @click="showCalculate(form.CalculateStepsList)"
                  ></van-image>
                </template>
              </van-field>

              <van-field class="custom-field">
                <template #label>
                  <span class="custom-field-label">{{
                    $t.goodsForecast.taxFeebearingParty
                  }}</span>
                </template>
                <template #input>
                  <div class="goodsForecast-radio">
                    <van-radio-group
                      v-model="form.TaxFeebearingParty"
                      direction="horizontal"
                    >
                      <van-radio :name="1">{{ $t.goodsForecast.shipper }}</van-radio>
                      <van-radio :name="2">{{ $t.goodsForecast.consignee }}</van-radio>
                    </van-radio-group>
                  </div>
                </template>
              </van-field>

              <van-field class="custom-field" :label="$t.goodsForecast.productImage">
                <template #input>
                  <van-uploader
                    v-model="form.images"
                    @click-upload="getCargoItemsIndex(0, 0)"
                    @delete="uploaderDelete(0, 0, $event)"
                    :max-count="99"
                    :after-read="afterRead"
                  >
                    <slot name="default" v-if="form.images.length == 0">
                      <van-image width="30" height="30" :src="qrCode"></van-image>
                      <div class="uploader-text1">
                        {{ $t.goodsForecast.uploaderText1 }}
                      </div>
                      <div class="uploader-text2">
                        {{ $t.goodsForecast.uploaderText2 }}
                      </div>
                    </slot>
                  </van-uploader>
                </template>
              </van-field>

              <!-- <van-field class="custom-field">
                <template #label>
                  <span class="custom-field-label">{{ $t.goodsForecast.isUnpack }}</span
                  ><van-image
                    width="15"
                    height="15"
                    :src="questionIcon"
                    @click="showQuestion"
                  ></van-image>
                </template>
                <template #input>
                  <div class="goodsForecast-radio">
                    <van-radio-group v-model="form.IsUnpack" direction="horizontal">
                      <van-radio :name="0">{{ $t.meta.no }}</van-radio>
                      <van-radio :name="1">{{ $t.meta.yes }}</van-radio>
                    </van-radio-group>
                  </div>
                </template>
              </van-field> -->
            </span>
            <div class="multi-table2" v-else>
              <van-field
                name="stepper"
                class="stepper"
                :label="$t.goodsForecast.stepperLabel"
              >
                <template #input>
                  <van-stepper
                    :min="1"
                    :max="10"
                    :value="form.cargoItems.length"
                    @minus="handleCargoDel(index)"
                    @plus="handleCargoAdd(index)"
                    :disable-input="true"
                  />
                </template>
              </van-field>
              <div
                v-for="(item, idx) in form.cargoItems"
                :key="idx"
                class="multi-table-wrapper"
              >
                <van-field
                  class="custom-field"
                  v-model="item.CargoName"
                  :label="$t.goodsForecast.cargoName + ' ' + (idx + 1)"
                  label-class="number-label"
                  :placeholder="$t.goodsForecast.input"
                  required
                  :rules="[
                    {
                      required: true,
                      message: $t.goodsForecast.input + ' ' + $t.goodsForecast.cargoName,
                    },
                    {
                      validator: asyncValidator,
                      message:
                        $t.goodsForecast.cargoName + ' ' + $t.goodsForecast.englishOnly,
                    },
                  ]"
                >
                  <template #button>
                    <van-button
                      size="small"
                      type="info"
                      class="customBtn"
                      native-type="button"
                      :disabled="!item.CargoName ? true : false"
                      @click="handleTranslate(item.CargoName, index, idx)"
                      >{{ $t.goodsForecast.translate }}</van-button
                    >
                  </template>
                </van-field>

                <van-field
                  class="custom-field"
                  v-model="item.CargoQuantity"
                  :label="$t.goodsForecast.cargoQuantity"
                  :placeholder="$t.goodsForecast.input"
                  oninput="if(isNaN(value)) { value = null } if(value.indexOf('.')>0){value=value.slice(0,value.indexOf('.')+3)}"
                  required
                  :rules="[
                    {
                      required: true,
                      message:
                        $t.goodsForecast.input + ' ' + $t.goodsForecast.cargoQuantity,
                    },
                  ]"
                >
                  <template #button v-if="item.QuantityUnit">
                    <span v-if="item.IsOther">{{ item.CustomeUnit }}</span>
                    <span v-else>{{ item.QuantityUnit }}</span>
                  </template>
                </van-field>

                <van-field
                  class="custom-field"
                  v-model="item.QuantityUnit"
                  :label="$t.goodsForecast.quantityUnit"
                  :placeholder="$t.goodsForecast.select"
                  readonly
                  required
                  :rules="[
                    {
                      required: true,
                      message:
                        $t.goodsForecast.select + ' ' + $t.goodsForecast.quantityUnit,
                    },
                  ]"
                  @click="pickerShow('showUnitPicker', index, idx)"
                />

                <van-field
                  class="custom-field"
                  v-model="item.CustomeUnit"
                  :label="$t.goodsForecast.customUnit"
                  :placeholder="$t.goodsForecast.input"
                  required
                  :rules="[
                    {
                      required: true,
                      message: $t.goodsForecast.input + ' ' + $t.goodsForecast.customUnit,
                    },
                  ]"
                  v-if="item.IsOther"
                />

                <van-field
                  class="custom-field"
                  v-model="item.GoodsValue"
                  :label="$t.goodsForecast.goodsValue"
                  :placeholder="$t.goodsForecast.input"
                  @blur="taxCalculator"
                  oninput="if(isNaN(value)) { value = null } if(value.indexOf('.')>0){value=value.slice(0,value.indexOf('.')+3)}"
                  required
                  :rules="[
                    {
                      required: true,
                      message: $t.goodsForecast.input + ' ' + $t.goodsForecast.goodsValue,
                    },
                  ]"
                >
                  <template #button v-if="item.CurrencySymbol">
                    <span>{{ item.CurrencySymbol }}</span>
                  </template>
                </van-field>

                <van-field
                  class="custom-field"
                  v-model="item.Currency"
                  :label="$t.goodsForecast.currency"
                  :placeholder="$t.goodsForecast.select"
                  readonly
                  required
                  :rules="[
                    {
                      required: true,
                      message: $t.goodsForecast.select + ' ' + $t.goodsForecast.currency,
                    },
                  ]"
                  @click="pickerShow('showCurrencyPicker', index, idx)"
                />

                <van-field
                  class="custom-field"
                  v-model="item.PTIdStr"
                  :label="$t.goodsForecast.productCategory"
                  :placeholder="$t.goodsForecast.select"
                  readonly
                  @click="pickerShow('showPtidPicker', index, idx)"
                  v-if="productTaxList && productTaxList.length > 0"
                />

                <van-field
                  class="custom-field"
                  v-model="item.TotalTax"
                  readonly
                  disabled
                  v-if="productTaxList && item.TotalTax"
                >
                  <template #label>
                    <span class="custom-field-label">{{ $t.goodsForecast.totalTax }}</span
                    ><van-image
                      width="15"
                      height="15"
                      :src="questionIcon"
                      @click="showCalculate(item.CalculateStepsList)"
                    ></van-image>
                  </template>
                </van-field>

                <van-field class="custom-field">
                  <template #label>
                    <span class="custom-field-label">{{
                      $t.goodsForecast.taxFeebearingParty
                    }}</span>
                  </template>
                  <template #input>
                    <div class="goodsForecast-radio">
                      <van-radio-group
                        v-model="item.TaxFeebearingParty"
                        direction="horizontal"
                      >
                        <van-radio :name="1">{{ $t.goodsForecast.shipper }}</van-radio>
                        <van-radio :name="2">{{ $t.goodsForecast.consignee }}</van-radio>
                      </van-radio-group>
                    </div>
                  </template>
                </van-field>

                <van-field class="custom-field" :label="$t.goodsForecast.productImage">
                  <template #input>
                    <van-uploader
                      v-model="item.images"
                      @click-upload="getCargoItemsIndex(index, idx)"
                      @delete="uploaderDelete(index, idx, $event)"
                      :max-count="99"
                      :after-read="afterRead"
                    >
                      <slot name="default" v-if="item.images.length == 0">
                        <van-image width="30" height="30" :src="qrCode"></van-image>
                        <div class="uploader-text1">
                          {{ $t.goodsForecast.uploaderText1 }}
                        </div>
                        <div class="uploader-text2">
                          {{ $t.goodsForecast.uploaderText2 }}
                        </div>
                      </slot>
                    </van-uploader>
                  </template>
                </van-field>

                <!-- <van-field class="custom-field">
                  <template #label>
                    <span class="custom-field-label">{{ $t.goodsForecast.isUnpack }}</span
                    ><van-image
                      width="15"
                      height="15"
                      :src="questionIcon"
                      @click="showQuestion"
                    ></van-image>
                  </template>
                  <template #input>
                    <div class="goodsForecast-radio">
                      <van-radio-group v-model="item.IsUnpack" direction="horizontal">
                        <van-radio :name="0">{{ $t.meta.no }}</van-radio>
                        <van-radio :name="1">{{ $t.meta.yes }}</van-radio>
                      </van-radio-group>
                    </div>
                  </template>
                </van-field> -->

                <div class="multi-table-corner" v-if="idx != 0">
                  <div class="multi-table-btn" @click="handleCargoDelByIndex(index, idx)">
                    <van-icon name="close" />
                  </div>
                </div>
              </div>
            </div>

            <van-field
              class="custom-field"
              required
              :rules="[
                {
                  required: true,
                  message:
                    $t.goodsForecast.select + ' ' + $t.goodsForecast.receivingAddress,
                },
              ]"
              clickable
              readonly
              :value="form.selectedAddress.text"
              :label="$t.goodsForecast.receivingAddress"
              :placeholder="$t.goodsForecast.select"
              @click="actionAddressSelection(form)"
              type="textarea"
              rows="3"
            />
          </van-collapse-item>
        </van-collapse>
      </div>

      <div class="tool-bar">
        <van-button block native-type="submit">{{ $t.goodsForecast.submit }}</van-button>
      </div>
    </van-form>

    <option-list
      event="showForecastFreightPrice"
      :options="fpidList"
      @onSelect="onSelectFpid"
    ></option-list>

    <option-list
      event="showForecastFreightPriceInfo"
      :options="fpdidList"
      @onSelect="onSelectFpdid"
    ></option-list>

    <van-popup v-model="showCurrencyPicker" position="bottom">
      <van-picker
        :title="$t.goodsForecast.currency"
        show-toolbar
        :confirm-button-text="$t.meta.confirm"
        :cancel-button-text="$t.meta.cancel"
        :columns="currencyList"
        @confirm="onCurrencyConfirm"
        @cancel="showCurrencyPicker = false"
      />
    </van-popup>

    <van-popup v-model="showUnitPicker" round position="bottom">
      <van-picker
        :title="$t.goodsForecast.quantityUnit"
        show-toolbar
        :columns="unitList"
        :confirm-button-text="$t.meta.confirm"
        :cancel-button-text="$t.meta.cancel"
        @confirm="onUnitConfirm"
        @cancel="showUnitPicker = false"
      />
    </van-popup>

    <van-popup v-model="showPtidPicker" round position="bottom">
      <van-picker
        :title="$t.goodsForecast.productCategory"
        show-toolbar
        :columns="productTaxList"
        :confirm-button-text="$t.meta.confirm"
        :cancel-button-text="$t.meta.cancel"
        @confirm="onPtidConfirm"
        @cancel="showPtidPicker = false"
      />
    </van-popup>
  </div>
</template>
<script>
import Vue from "vue";
import {
  Form,
  Field,
  Button,
  Uploader,
  Image,
  Tag,
  Stepper,
  Collapse,
  CollapseItem,
  Popover,
  Picker,
  Radio,
  RadioGroup,
} from "vant";
import OptionList from "@components/optionList/OptionList.vue";
import Selection from "@/views/main/shippingAddress-selection/index.js";

Vue.use(Form)
  .use(Field)
  .use(Button)
  .use(Uploader)
  .use(Image)
  .use(Tag)
  .use(Stepper)
  .use(Collapse)
  .use(CollapseItem)
  .use(Popover)
  .use(Picker)
  .use(Radio)
  .use(RadioGroup);

export default {
  name: "goodsForecast",
  components: {
    OptionList,
  },
  data() {
    return {
      pageType: "new",
      qrCode: require("@/assets/img/goodsForecast/upload-fill.png"),
      questionIcon: require("@/assets/img/goodsForecast/question.png"),
      fpidList: [],
      fpdidList: [],
      currencyList: [],
      unitList: [],
      expressNumbers: [
        {
          ExpressNumber: "",
        },
      ],
      step: 1,
      currentIndex: 0,
      currentIdx: 0,
      forms: [],
      isEdit: false,
      preData: {
        fpid: null,
        fpdid: null,
      },
      productTaxList: [],
      selectedAddressText: "",
      activeNames: 0,
      showCurrencyPicker: false,
      showUnitPicker: false,
      showPtidPicker: false,
    };
  },
  created() {
    const query = this.$route.query;
    this.pageType = query.pageType;
    if (this.pageType == "new") {
      var data = JSON.parse(localStorage.getItem("goodsForecast"));
      this.preData.fpid = data.fpid;
      this.preData.fpdid = data.fpdid;
      this.loadFreightPriceInfo(data.fpid.value, null);
      this.getOptions1();
    }
    if (this.pageType == "edit") {
      var order = JSON.parse(localStorage.getItem("goodsForecast"));
      this.isEdit = true;
      this.step = 2;
      this.loadFreightPriceInfo(order.FPId, order.FPDId).then((success) => {
        if (success) {
          this.getOptions2(order.CRId).then((success) => {
            if (success) {
              this.applyData(order);
              this.taxCalculator();
            }
          });
        }
      });
    }
  },
  methods: {
    handleTranslate(text, index, idx) {
      return new Promise((resolve) => {
        this.$commonMethod.showLoading();
        let param = {
          Text: text,
        };
        this.$api.order
          .translateText(param)
          .then((res) => {
            var data = res.data;
            if (this.pageType == "edit") {
              this.forms[0].CargoName = data.TranslateText;
            } else {
              this.forms[index].cargoItems[idx].CargoName = data.TranslateText;
            }
            this.$commonMethod.hideLoading();
            resolve(true);
          })
          .catch((error) => {
            this.$commonMethod.hideLoading();
            this.$commonEnv.commonAction(this.$commonEnv.actionType.showDialog, {
              msg: error.message,
            });
          });
      });
    },
    asyncValidator(val) {
      return new Promise((resolve) => {
        var isEnglishLetters = (str) => {
          return /^[A-Za-z0-9 .,;:?!()\[\]{}\'\"+\-*/=<>\$%@#&_|\\]+$/.test(str);
        };
        if (isEnglishLetters(val)) {
          resolve(true);
        } else {
          resolve(false);
        }
      });
    },
    getOptions1() {
      return new Promise((resolve) => {
        this.$commonMethod.showLoading();
        Promise.all([
          this.getCurrencyList(),
          this.getProcurementQuotationUnitList(),
        ]).then((success) => {
          if (success) {
            resolve(true);
          }
          this.$commonMethod.hideLoading();
        });
      });
    },
    getOptions2(CRId) {
      return new Promise((resolve) => {
        this.$commonMethod.showLoading();
        Promise.all([
          this.getCurrencyList(),
          this.getProcurementQuotationUnitList(),
          this.getFreightPriceListByPage(),
          this.getCustomerReceivingList(CRId),
        ]).then((success) => {
          if (success) {
            resolve(true);
          }
          this.$commonMethod.hideLoading();
        });
      });
    },
    onPtidConfirm(item) {
      if (!item) {
        return;
      }
      if (this.pageType == "edit") {
        this.forms[0].PTId = item.value;
        this.forms[0].PTIdStr = item.text;
      } else {
        this.forms[this.currentIndex].cargoItems[this.currentIdx].PTId = item.value;
        this.forms[this.currentIndex].cargoItems[this.currentIdx].PTIdStr = item.text;
      }
      this.showPtidPicker = false;
      this.taxCalculator();
    },
    onUnitConfirm(item) {
      if (!item) {
        return;
      }
      if (this.pageType == "edit") {
        this.forms[0].QuantityUnit = item.value;
        this.forms[0].IsOther = item.other;
      } else {
        this.forms[this.currentIndex].cargoItems[this.currentIdx].QuantityUnit =
          item.value;
        this.forms[this.currentIndex].cargoItems[this.currentIdx].IsOther = item.other;
      }
      this.showUnitPicker = false;
    },
    onCurrencyConfirm(item) {
      if (!item) {
        return;
      }
      if (this.pageType == "edit") {
        this.forms[0].SCId = item.value;
        this.forms[0].Currency = item.text;
        this.forms[0].CurrencySymbol = item.CurrencySymbol;
      } else {
        this.forms[this.currentIndex].cargoItems[this.currentIdx].SCId = item.value;
        this.forms[this.currentIndex].cargoItems[this.currentIdx].Currency = item.text;
        this.forms[this.currentIndex].cargoItems[this.currentIdx].CurrencySymbol =
          item.CurrencySymbol;
      }
      this.showCurrencyPicker = false;
      this.taxCalculator();
    },
    pickerShow(pickerName, index, idx) {
      this.getCargoItemsIndex(index, idx);
      this[pickerName] = true;
    },
    actionAddressSelection(form) {
      const selection = Selection();
      selection.onSelected = (address) => {
        form.selectedAddress.value = address.CRId;
        form.selectedAddress.text =
          address.ReceivingName +
          " , " +
          address.PhoneNumber +
          " , " +
          address.ReceivingAddress;
      };
      selection.show();
    },
    applyData(data) {
      var images = [];
      for (var image of data.ProductPictureList) {
        images.push({
          url: this.imgUrlFilter(image),
          origin: image,
        });
      }
      var productCategory = null;
      productCategory = this.productTaxList.find((p) => p.value == data.PTId);
      var currency = null;
      currency = this.currencyList.find((c) => c.text == data.Currency);
      var param = {
        COId: data.COId,
        ExpressNumber: data.ExpressNumber,
        FPId: data.FPId,
        FPDId: data.FPDId,
        //cargo
        CargoName: data.CargoName,
        CargoQuantity: data.CargoQuantity,
        SCId: data.SCId,
        Currency: data.Currency,
        GoodsValue: data.GoodsValue,
        CurrencySymbol: currency ? currency.CurrencySymbol : "",
        QuantityUnit: data.IsOther ? data.CustomeUnit : data.QuantityUnit,
        IsUnpack: data.IsUnpack,
        ProductPictureList: data.ProductPictureList,
        fpid: { text: data.CountryName, value: data.FPId },
        fpdid: { text: data.CargoCategory, value: data.FPDId },
        images: images,
        selectedAddress: { text: this.selectedAddressText, value: data.CRId },
        PTId: data.PTId,
        PTIdStr: productCategory ? productCategory.text : "",
        TaxFeebearingParty: data.TaxFeebearingParty ? data.TaxFeebearingParty : 1,
        TotalTax: 0,
        CalculateStepsList: [],
      };
      this.forms.push(param);
    },
    formatProductTaxList(details, fpdid) {
      var list = [];
      var detail = [];
      if (this.pageType == "new") {
        detail = details.find((p) => p.FPDId == this.preData.fpdid.value);
      }
      if (this.pageType == "edit") {
        detail = details.find((p) => p.FPDId == fpdid);
      }
      if (detail && detail.ProductTaxList && detail.ProductTaxList.length) {
        detail.ProductTaxList.forEach((item) => {
          let data = {
            text: item.ProductCategory,
            value: item.PTId,
          };
          list.push(data);
        });
      }
      this.productTaxList = list;
    },
    nextStep() {
      var render = (arrs) => {
        for (var arr of arrs) {
          if (arr) {
            this.forms.push({
              ExpressNumber: arr.ExpressNumber,
              FPId: "",
              FPDId: "",
              cargoItems: [
                {
                  CargoName: "",
                  CargoQuantity: null,
                  SCId: null,
                  Currency: "",
                  CurrencySymbol: "",
                  GoodsValue: null,
                  QuantityUnit: "",
                  IsOther: false,
                  CustomeUnit: "",
                  IsUnpack: 0,
                  ProductPictureList: [],
                  images: [],
                  PTId: null,
                  PTIdStr: "",
                  TaxFeebearingParty: 1,
                  TotalTax: 0,
                  CalculateStepsList: [],
                },
              ],
              fpid: this.preData.fpid ? this.preData.fpid : { text: "", value: "" },
              fpdid: this.preData.fpdid ? this.preData.fpdid : { text: "", value: "" },
              selectedAddress: { text: "", value: "" },
            });
          }
        }
      };
      this.step = 2;
      render(this.expressNumbers);
    },
    nextStepFailed(errorInfo) {
      if (errorInfo && errorInfo.errors.length > 0) {
        this.$commonEnv.commonAction(this.$commonEnv.actionType.showDialog, {
          msg: errorInfo.errors[0].message,
        });
      }
    },
    handleDelByIndex(index) {
      if (this.expressNumbers.length > 0) {
        this.expressNumbers.splice(index, 1);
      }
    },
    handleDel() {
      if (this.expressNumbers.length > 0) {
        this.expressNumbers.pop();
      }
    },
    handleAdd() {
      this.expressNumbers.push({
        ExpressNumber: "",
      });
    },
    handleCargoDelByIndex(index, idx) {
      if (this.forms[index].cargoItems.length > 0) {
        this.forms[index].cargoItems.splice(idx, 1);
      }
    },
    handleCargoDel(index) {
      if (this.forms[index].cargoItems.length > 0) {
        this.forms[index].cargoItems.pop();
      }
    },
    handleCargoAdd(index) {
      this.forms[index].cargoItems.push({
        CargoName: "",
        CargoQuantity: null,
        SCId: null,
        Currency: "",
        CurrencySymbol: "",
        GoodsValue: null,
        QuantityUnit: "",
        IsOther: false,
        CustomeUnit: "",
        IsUnpack: 0,
        ProductPictureList: [],
        images: [],
        PTId: null,
        PTIdStr: "",
        TaxFeebearingParty: 1,
        TotalTax: 0,
        CalculateStepsList: [],
      });
    },
    imgUrlFilter(value) {
      return this.$api.formatImageUrl(value);
    },
    onShowFpid(index) {
      this.currentIndex = index;
      this.$bus.$emit("showForecastFreightPrice", true);
    },
    onSelectFpid(item) {
      var data = this.forms[this.currentIndex];
      data.fpid.text = item.text;
      data.fpid.value = item.value;
      this.resetFpdid();
      this.loadFreightPriceInfo(data.fpid.value, null);
    },
    resetFpdid() {
      var data = this.forms[this.currentIndex];
      data.fpdid.text = "";
      data.fpdid.value = "";
    },
    onShowFpdid(index) {
      this.currentIndex = index;
      this.$bus.$emit("showForecastFreightPriceInfo", true);
    },
    onSelectFpdid(item) {
      var data = this.forms[this.currentIndex];
      data.fpdid.text = item.text;
      data.fpdid.value = item.value;
      this.resetPtid();
      this.loadFreightPriceInfo(data.fpid.value, data.fpdid.value);
    },
    resetPtid() {
      var data = this.forms[this.currentIndex];
      data.PTIdStr = "";
      data.PTId = "";
    },
    onSubmit() {
      var param = null;
      var request = null;
      if (this.isEdit) {
        var form = this.forms[0];
        param = {
          COId: form.COId,
          ExpressNumber: form.ExpressNumber,
          FPId: form.fpid.value,
          FPDId: form.fpdid.value,
          CRId: form.selectedAddress.value,
          //cargo
          CargoName: form.CargoName,
          CargoQuantity: form.CargoQuantity,
          SCId: form.SCId,
          Currency: form.Currency,
          GoodsValue: form.GoodsValue,
          QuantityUnit: form.IsOther ? form.CustomeUnit : form.QuantityUnit,
          IsUnpack: form.IsUnpack,
          PTId: form.PTId,
          TaxFeebearingParty: form.TaxFeebearingParty,
          ProductPictureList: form.ProductPictureList,
        };
        request = this.$api.order.editCustomerOrder(param);
      } else {
        param = [];
        for (var form of this.forms) {
          for (var item of form.cargoItems) {
            param.push({
              ExpressNumber: form.ExpressNumber,
              FPId: form.fpid.value,
              FPDId: form.fpdid.value,
              CRId: form.selectedAddress.value,
              //cargoItems
              CargoName: item.CargoName,
              CargoQuantity: item.CargoQuantity,
              SCId: item.SCId,
              Currency: item.Currency,
              GoodsValue: item.GoodsValue,
              QuantityUnit: item.IsOther ? item.CustomeUnit : item.QuantityUnit,
              IsUnpack: item.IsUnpack,
              PTId: item.PTId,
              TaxFeebearingParty: item.TaxFeebearingParty,
              ProductPictureList: item.ProductPictureList,
            });
          }
        }
        request = this.$api.order.addCustomerOrderCargoPreInput(param);
      }
      this.$commonMethod.showLoading();
      request
        .then((res) => {
          this.$commonMethod.hideLoading();
          var message = res.message;
          if (this.pageType == "new") {
            message = this.$t.goodsForecast.createText;
          }
          this.$commonMethod.dialogAlert(message, () => {
            if (this.pageType == "new") {
              this.$commonEnv.commonAction(this.$commonEnv.actionType.backHome);
            } else {
              this.$commonEnv.commonAction(this.$commonEnv.actionType.pop);
            }
          });
        })
        .catch((error) => {
          this.$commonMethod.hideLoading();
          this.$commonEnv.commonAction(this.$commonEnv.actionType.showDialog, {
            msg: error.message,
          });
        });
    },
    onFailed(errorInfo) {
      if (errorInfo && errorInfo.errors.length > 0) {
        this.$commonEnv.commonAction(this.$commonEnv.actionType.showDialog, {
          msg: errorInfo.errors[0].message,
        });
      }
    },
    getCustomerReceivingList(CRId) {
      return new Promise((resolve) => {
        let param = {
          CRId: CRId,
        };
        this.$api.address
          .getCustomerReceivingList(param)
          .then((res) => {
            const data = res.data[0];
            this.selectedAddressText =
              data.ReceivingName +
              " , " +
              data.PhoneNumber +
              " , " +
              data.ReceivingAddress;
            resolve(true);
          })
          .catch((error) => {
            this.$commonEnv.commonAction(this.$commonEnv.actionType.showDialog, {
              msg: error.message,
            });
          });
      });
    },
    getFreightPriceListByPage() {
      var param = {};
      return new Promise((resolve) => {
        this.$api.customerManagement
          .getFreightPriceListByPage(param)
          .then((res) => {
            this.formatFreightPrice(res.data.Data);
            resolve(true);
          })
          .catch((error) => {
            this.$commonEnv.commonAction(this.$commonEnv.actionType.showDialog, {
              msg: error.message,
            });
          });
      });
    },
    formatFreightPrice(items) {
      items.forEach((item) => {
        let data = {
          text: item.CountryName,
          image: item.NationalFlagPicture,
          value: item.FPId,
        };
        this.fpidList.push(data);
      });
    },
    loadFreightPriceInfo(id, fpdid) {
      return new Promise((resolve) => {
        this.$commonMethod.showLoading();
        var param = {
          FPId: id,
        };
        this.$api.customerManagement
          .loadFreightPriceInfo(param)
          .then((res) => {
            var data = res.data.DetailList;
            this.formatFreightPriceInfo(data);
            this.formatProductTaxList(data, fpdid);
            this.$commonMethod.hideLoading();
            resolve(true);
          })
          .catch((error) => {
            this.$commonMethod.hideLoading();
            this.$commonEnv.commonAction(this.$commonEnv.actionType.showDialog, {
              msg: error.message,
            });
          });
      });
    },
    formatFreightPriceInfo(items) {
      var list = [];
      items.forEach((item) => {
        let data = {
          text: item.CargoCategory,
          value: item.FPDId,
        };
        list.push(data);
      });
      this.fpdidList = list;
    },
    getCurrencyList() {
      return new Promise((resolve) => {
        this.$api.account
          .getSystemAvailableCurrencyList()
          .then((res) => {
            var result = [];
            res.data.forEach((item) => {
              let data = {
                text: item.CurrencySn,
                value: item.SCId,
                CurrencySymbol: item.CurrencySymbol,
              };
              result.push(data);
            });
            this.currencyList = result;
            resolve(true);
          })
          .catch((error) => {
            this.$commonEnv.commonAction(this.$commonEnv.actionType.showDialog, {
              msg: error.message,
            });
          });
      });
    },
    getProcurementQuotationUnitList() {
      return new Promise((resolve) => {
        this.$api.order
          .getProcurementQuotationUnitList()
          .then((res) => {
            var result = [];
            res.data.forEach((item) => {
              let data = {
                text: item.UnitName,
                value: item.UnitName,
                other: false,
              };
              result.push(data);
            });
            result.push({
              text: this.$t.goodsForecast.other,
              value: this.$t.goodsForecast.other,
              other: true,
            });
            this.unitList = result;
            resolve(true);
          })
          .catch((error) => {
            this.$commonEnv.commonAction(this.$commonEnv.actionType.showDialog, {
              msg: error.message,
            });
          });
      });
    },
    taxCalculator() {
      var param = {};
      if (this.pageType == "new") {
        var data = this.forms[this.currentIndex].cargoItems[this.currentIdx];
        param.FPId = this.preData.fpid.value;
        param.FPDId = this.preData.fpdid.value;
        param.GoodsValue = data.GoodsValue;
        param.SCId = data.SCId;
        param.PTId = data.PTId;
      }
      if (this.pageType == "edit") {
        var data = this.forms[this.currentIndex];
        param.FPId = data.fpid.value;
        param.FPDId = data.fpdid.value;
        param.GoodsValue = data.GoodsValue;
        param.SCId = data.SCId;
        param.PTId = data.PTId;
      }
      var request = () => {
        this.$api.order
          .taxCalculator(param)
          .then((res) => {
            if (this.pageType == "new") {
              var data = this.forms[this.currentIndex].cargoItems[this.currentIdx];
              data.TotalTax = res.data.Total;
              data.CalculateStepsList = res.data.CalculateStepsList;
            }
            if (this.pageType == "edit") {
              var data = this.forms[this.currentIndex];
              data.TotalTax = res.data.Total;
              data.CalculateStepsList = res.data.CalculateStepsList;
            }
          })
          .catch((error) => {
            this.$commonEnv.commonAction(this.$commonEnv.actionType.showDialog, {
              msg: error.message,
            });
          });
      };
      if (param.GoodsValue && param.SCId) {
        if (this.productTaxList && this.productTaxList.length > 0) {
          if (param.PTId) {
            request();
          }
        } else {
          request();
        }
      }
    },
    uploaderDelete(index, idx, event) {
      var form = null;
      if (this.pageType == "edit") {
        form = this.forms[index];
      } else {
        form = this.forms[index].cargoItems[idx];
      }
      var pIdx = form.ProductPictureList.findIndex((url) => {
        return url === event.origin;
      });
      form.ProductPictureList.splice(pIdx, 1);
    },
    getCargoItemsIndex(index, idx) {
      this.currentIndex = index;
      this.currentIdx = idx;
    },
    afterRead(file) {
      this.$commonMethod.showLoading();
      var formData = new FormData();
      formData.append("file", file.file);
      this.$api.user
        .uploadImgFile(formData)
        .then((res) => {
          this.$commonEnv.commonAction(this.$commonEnv.actionType.showNotify, {
            titleMsg: this.$t.meta.uploadSuccess,
            type: "success",
          });
          var form = null;
          if (this.pageType == "edit") {
            form = this.forms[this.currentIndex];
          } else {
            form = this.forms[this.currentIndex].cargoItems[this.currentIdx];
          }
          form.ProductPictureList.push(res.data);
          this.$commonMethod.hideLoading();
        })
        .catch(() => {
          this.$commonMethod.hideLoading();
          this.$commonEnv.commonAction(this.$commonEnv.actionType.showDialog, {
            msg: this.$t.meta.uploadFail,
          });
        });
    },
    showCalculate(text) {
      this.$commonMethod.customAlert(
        {
          message: text.join("<br/>"),
          showCancelButton: false,
          confirmButtonText: this.$t.alert.confirmButtonText,
        },
        () => {},
        () => {}
      );
    },
    showQuestion() {
      this.$commonEnv.commonAction(this.$commonEnv.actionType.showDialog, {
        msg: this.$t.goodsForecast.question,
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.goodsForecast {
  ::v-deep .number-label {
    line-height: 33px;
  }
  ::v-deep .customBtn {
    background: #2750aa;
    border: none;
    border-radius: 5px;
    height: 30px;
    .van-button__text {
      font-size: 14px !important;
    }
  }
  ::v-deep .van-form {
    .van-cell__title {
      flex: unset !important;
    }
  }
  ::v-deep .custom-field::before {
    left: 15px !important;
  }
  ::v-deep .custom-field::after {
    border: none !important;
  }
  ::v-deep .van-field--disabled {
    .van-field__label,
    .van-field__control {
      color: #323233 !important;
      -webkit-text-fill-color: #323233 !important;
    }
  }
  .tag-group {
    background: #f9fafd;
    .van-tag {
      background: #2750aa;
    }
  }
  .goodsForecast-radio {
    .van-radio {
      font-size: 14px;
      margin-right: 30px;
      ::v-deep .van-radio__label {
        color: #323233;
      }
      ::v-deep .van-radio__icon--checked {
        .van-icon-success {
          background-color: #2750aa;
          border-color: #2750aa;
        }
      }
    }
  }
  .multi-table {
    .van-cell::after {
      border: none !important;
    }
    .stepper {
      border-bottom: 2px solid #e4e9f0;
      text-align: center;
      ::v-deep .van-field__label {
        margin-top: 2px;
        display: inline-block;
        color: #000;
        font-weight: 500;
        width: 50% !important;
      }
      ::v-deep .van-field__control {
        display: inline-block !important;
        text-align: right;
        width: 100%;
      }
    }
    .multi-table-wrapper {
      border-bottom: 2px solid #e4e9f0;
      padding-bottom: 10px;
      position: relative;
    }
    .multi-table-corner {
      position: absolute;
      top: 7%;
      right: 4%;
      line-height: 1;
      .multi-table-btn {
        font-size: 20px;
        color: #000;
      }
    }
  }
  .multi-table2 {
    .van-cell::after {
      border: none !important;
    }
    .stepper {
      text-align: center;
      background: #f9fafd;
      ::v-deep .van-field__label {
        margin-top: 2px;
        display: inline-block;
        color: #000;
        font-weight: 500;
        width: 50% !important;
      }
      ::v-deep .van-field__control {
        display: inline-block !important;
        text-align: right;
        width: 100%;
      }
    }
    .multi-table-wrapper {
      border-bottom: 2px solid #e4e9f0;
      padding-bottom: 10px;
      position: relative;
      .half-field {
        width: 50%;
        display: inline-block;
      }
    }
    .multi-table-corner {
      position: absolute;
      top: 2%;
      right: 5%;
      line-height: 1;
      .multi-table-btn {
        font-size: 20px;
        color: #000;
      }
    }
  }
  .forms-wrapper {
    border-bottom: 2px solid #e4e9f0;
    .van-collapse:after {
      border: none;
    }
    .van-collapse {
      ::v-deep .van-collapse-item__title {
        padding: 0px;
        display: block;
      }
      ::v-deep .van-collapse-item__content {
        padding: 0px;
      }
      ::v-deep .van-collapse-item--border {
        border-top: 2px solid #e4e9f0;
      }
      .van-collapse-item {
        padding-bottom: 10px;
        ::v-deep .van-cell--clickable:active {
          background-color: transparent !important;
        }
        ::v-deep .van-icon-arrow {
          color: #000;
          margin-left: 50%;
        }
        ::v-deep .van-cell:after {
          border: none;
        }
        ::v-deep .van-cell:before {
          border: none;
        }
      }
    }
  }
  .custom-field {
    width: auto;
    display: block;
    ::v-deep .van-field__label {
      width: auto;
      margin-left: 10px;
      margin-bottom: 10px;
      font-weight: 500;
      color: #000;
      .custom-field-label {
        vertical-align: middle;
      }
      .van-image {
        margin-left: 5px;
        vertical-align: middle;
      }
    }
    ::v-deep .van-cell__value {
      border: 2px solid #e4e9f0;
      background: #f9fafd;
      border-radius: 10px;
      padding: 10px 15px;
      .van-field__control::placeholder {
        font-weight: normal;
        color: #999 !important;
      }
      .van-uploader {
        width: 100%;
        .van-uploader__upload {
          margin: 0px 3% 3% 0px;
          width: 100px;
          height: 100px;
          background: transparent;
        }
        .van-uploader__preview {
          margin: 0px 3% 3% 0px;
          position: relative;
          .van-image {
            margin: auto;
            width: 100px;
            height: 100px;
          }
          .van-uploader__preview-delete {
            top: 0px;
            right: 0px;
            width: 20px;
            height: 20px;
            border-radius: 0 0 0 15px;
            i {
              font-size: 22px;
            }
          }
        }
        .van-uploader__input-wrapper {
          width: 100%;
          text-align: center;
          .uploader-text1 {
            color: #898da1;
            font-size: 12px;
          }
          .uploader-text2 {
            color: #999999;
            font-size: 10px;
          }
        }
      }
      .van-switch--on {
        background-color: #2750aa !important;
      }
    }
  }
  .tool-bar {
    width: 100%;
    position: fixed;
    left: 0;
    bottom: 0;
    z-index: 10;
    padding-bottom: env(safe-area-inset-bottom);
    .van-button {
      border: none;
      border-radius: 0px;
      color: #ffffff;
      background: #2750aa !important;
    }
  }
}
</style>
